module.exports = __webpack_public_path__ + "img/ypo-banner.fbb0370c.png";